import { render, staticRenderFns } from "./Sharingandreviews.vue?vue&type=template&id=be712334&"
import script from "./Sharingandreviews.vue?vue&type=script&lang=js&"
export * from "./Sharingandreviews.vue?vue&type=script&lang=js&"
import style0 from "./Sharingandreviews.vue?vue&type=style&index=0&id=be712334&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports